import { Directive, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Icons, LauncherTypes } from '../../constants';
import { AppContext } from '../../contracts';
import { MenuHelper } from '../../helpers';
import { ContextStateService } from '../../services';
import { ModalService } from '../../services/modal.service';
import { LauncherModel } from '../../models';
import { openUrl } from 'src/app/pages-frontend/utils/utils';

@Directive()
export abstract class BaseMenuComponent implements OnDestroy {
  context$ = this.contextState.currentContext;
  context: AppContext;
  menuItems: LauncherModel[] = [];
  launcherTypes = LauncherTypes;
  icons = Icons;
  sub$: Array<Subscription> = [];

  constructor(
    protected router: Router,
    protected contextState: ContextStateService,
    private modalService: ModalService
  ) {}

  handleNavigation(item) {

    switch (item.type) {

      // KS, 20260610
      case LauncherTypes.ROUTE: {
        this.router.navigate([item.path]);
      }
      break;

      case LauncherTypes.POPUP:
        this.openModal(item);
        break;
      case LauncherTypes.GROW_IFRAME:

        // KS TEST
        /*
        if(item.path.indexOf('/dashboard') >= 0) {
          this.router.navigate(['/v2/dashboard']);
        }
        else if (item.path.indexOf('/media/started') >= 0) {
          this.router.navigate(['/v2/learning-space']);
        }
        else if (item.path.indexOf('/catalogue') >= 0) {
          this.router.navigate(['/v2/catalogue']);
        }
        else {
          this.handleAppNavigation(item);
        }
        */
          
        this.handleAppNavigation(item);

        break;
      case LauncherTypes.IFRAME:
        this.handleAppNavigation(item);
        break;
      case LauncherTypes.FOLDER:
        this.handleFolderNavigation(item);
        break;
      case LauncherTypes.WINDOW:
        this.handleExternalNavigation(item);
        break;
      default:
        break;
    }
  }

  openModal(item: any) {
    this.modalService.open(item);
  }

  handleFolderNavigation(item) {
    const app = MenuHelper.findFirstFrameEntry(item.items);
    if (app) {
      this.handleAppNavigation(app);
    } else if (item.items?.length) {
      this.handleFolderWithoutFrameEntries(item);
    }
  }

  handleAppNavigation(item) {
    this.router.navigate([`/${this.context.key}/frame/${item.id}`]);
  }

  handleExternalNavigation(item) {
    // Frueher per DOM-Anchor geoeffnet — das lief an der zentralen Absicherung
    // in openUrl() (Protokoll-Allowlist, noopener/noreferrer) vorbei:
    // const anchor = document.createElement('a');
    // anchor.href = item.baseUrl + item.path;
    // anchor.target = '_blank';
    // anchor.click();
    openUrl(item.baseUrl + item.path);
  }

  handleFolderWithoutFrameEntries(item): void {}

  checkPath(item) {
    // ROUTE launchers (e.g. /admin/statistics/dashboard) are not frame pages: compare the
    // router path (without query string/fragment) with the launcher path.
    if (item.type === LauncherTypes.ROUTE) {
      return !!item.path && this.router.url.split(/[?#]/)[0] === item.path;
    }
    return this.router.url === `/${this.context.key}/frame/${encodeURIComponent(item.id)}`;
  }

  getActivatedLink(links) {
    let activatedLink = null;
    links.forEach((item) => {
      if (this.checkPath(item)) {
        activatedLink = item;
      }
      if (item.items?.length && !activatedLink) {
        activatedLink = this.getActivatedLink(item.items);
      }
    });
    return activatedLink;
  }

  getParentNodes(node): any[] {
    const parents = [];
    let currentLevel = node;
    while (currentLevel.parent) {
      const parent = currentLevel.parent;
      parents.push(parent);
      currentLevel = parent;
    }
    return parents;
  }

  getTopLevelParentNode(node) {
    const parentNodes = this.getParentNodes(node);
    return parentNodes[parentNodes.length - 1];
  }

  ngOnDestroy(): void {
    this.sub$.map((subscriber) => subscriber.unsubscribe());
  }
}
